'use strict'

angular
  .module('surfsightApp.controllers')
  .controller('organizationDefaultPrivacySettingsEditController', [
    '$scope',
    '$mdDialog',
    '$rootScope',
    '$filter',
    '$mdColors',
    '$localStorage',
    '$http',
    '$mdToast',
    function (
      $scope,
      $mdDialog,
      $rootScope,
      $filter,
      $mdColors,
      $localStorage,
      $http,
      $mdToast
    ) {
      const $translate = $filter('translate')
      $scope.themePrimary = $mdColors.getThemeColor('primary')
      $scope.themeAccent = $mdColors.getThemeColor('accent')
      $scope.showMessageToast = function (message) {
        var toast = $mdToast
          .simple()
          .textContent(message)
          .action($translate('ok'))
          .position('top right')
          .actionKey('F1')
          .hideDelay(5000)
        $mdToast.show(toast).then(function (response) {
          if (response == 'ok') {
          }
        })
      }

      const handleServerError = error => {
        $scope.$emit('handleServerError', error)
      }

      $scope.isRestrictedUser =
        $localStorage.userDetails.accessLevel === 'viewer'
      $scope.confirmUpdateOrgDefaultPrivacySettings = () => {
        $mdDialog.hide($scope.privacySettings)
      }
      $scope.cancel = () => {
        $mdDialog.cancel()
      }

      const loadOrgDefaultPrivacySettings = async () => {
        await $http({
          method: 'GET',
          url:
            V2_BASEURL +
            `/organizations/${$localStorage.currentUserOrganization.id}/privacy-config`
        })
          .then(function (response) {
            $scope.privacySettings = response.data.data
          })
          .catch(error => {
            handleServerError(error)
            $scope.showMessageToast($translate('errorOccurredPleaseTryAgain'))
          })
      }
      loadOrgDefaultPrivacySettings()
    }
  ])
